import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import PdpEmail from '../PlantDetail/pdpEmail';
var NotifyButton = function (_a) {
    var djangoPk = _a.djangoPk, plantName = _a.plantName, _b = _a.showTitle, showTitle = _b === void 0 ? false : _b;
    var _c = useState(false), overlay = _c[0], setOverlay = _c[1];
    var handleClick = function (e) {
        if (e) {
            e.preventDefault();
        }
        setOverlay(function (prev) { return !prev; });
    };
    var closeOverlay = function () {
        setOverlay(false);
    };
    return (React.createElement("div", { className: "notify_btn" },
        React.createElement("div", null,
            React.createElement("button", { type: "button", className: "btn primary inverted", onClick: handleClick }, "Notify me")),
        showTitle && (React.createElement("div", null,
            React.createElement("p", null, "Notify me when this item is available on Plant Lust."))),
        React.createElement(Modal, { onClose: function () {
            }, open: overlay },
            React.createElement(Box, { className: "options_modal notify_me" },
                React.createElement("button", { type: "button", onClick: function () {
                        setOverlay(false);
                    }, className: "close_btn" },
                    React.createElement(CloseIcon, null)),
                React.createElement(Box, { className: "options_modal_wrapper" },
                    React.createElement("div", { className: "pdp_email_modal" },
                        React.createElement("div", { className: "modal_item_container" },
                            React.createElement(PdpEmail, { plantId: djangoPk, plantName: plantName, closeModal: closeOverlay, isNotifyModal: true }))))))));
};
export default NotifyButton;
